import { User, Network } from "lucide-react";

/**
 * ScopeToggle — segmented control "Próprios" | "Toda a rede".
 *
 * Visual minimalista para a barra de filtros. Mantém o conceito unificado em
 * todas as páginas que filtram entre os negócios próprios e os da downline.
 */
export default function ScopeToggle({ value, onChange, testid = "scope-toggle", className = "" }) {
  const opts = [
    { id: "own", label: "Próprios", icon: User },
    { id: "all", label: "Toda a rede", icon: Network },
  ];
  return (
    <div data-testid={testid}
      className={`inline-flex items-center bg-white border border-[#E6E1D6] rounded-full p-0.5 text-xs ${className}`}>
      {opts.map((o) => {
        const Icon = o.icon;
        const active = value === o.id;
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => onChange(o.id)}
            data-testid={`${testid}-${o.id}`}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full transition font-medium ${
              active
                ? "bg-[#0F1829] text-white shadow-sm"
                : "text-[#4B5563] hover:text-[#0F1829]"
            }`}
          >
            <Icon size={12} /> {o.label}
          </button>
        );
      })}
    </div>
  );
}
